// @ts-nocheck
import styled from '@emotion/styled';

import { colors, fonts } from '../../styles';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const BannerText = styled('span')`
  color: ${colors.white};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.medium};
  line-height: 1.36;
`;
